/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable linebreak-style */
/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import React from 'react';
import { useAmp } from 'next/amp';
import PropTypes from 'prop-types';
import parse, { domToReact } from 'html-react-parser';
import dynamic from 'next/dynamic';
import { Sentry } from 'root/utils/raven';

import useDeviceScreen from 'root/hooks/useDeviceScreen';
import get from 'base-ui/dist/underline/get';
import map from 'base-ui/dist/underline/map';
import omit from 'object.omit';
import pick from 'object.pick';
import Image from 'components/Image';
import uuid from 'uuid/v4';
import InsertAdUnit from 'utils/RenderHtmlReact/InsertAdUnit';
import ParseImgs from 'utils/RenderHtmlReact/ParseImgs';
import htmlTags from './htmlTags';

const AdManager = dynamic(() => import('components/AdManager'));

/**
 * Render HTML as React components
 * @param text
 * @param post
 * @param preview
 * @param withoutElement
 * @returns {*}
 * @constructor
 */
const RenderHtmlReact = ({ text, post, preview, withoutElement }) => {
  try {
    const { isPhone, width } = useDeviceScreen();
    const isAmp = useAmp();

    const fixTextForParse = (v) => v.replace(new RegExp(';quot;quot;quot;,times,serif;', 'g'), '');

    const optionsParse = {
      replace: ({ name, attribs, children }) => {
        if (attribs && name === 'iframe' && isAmp) {
          const propsWhitelist = [
            'title', 'src', 'width', 'height', 'scrolling', 'class',
            'srcdoc', 'frameborder', 'allowfullscreen', 'allowpaymentrequest',
            'allowtransparency', 'referrerpolicy'
          ];
          const allowedProps = pick(attribs, propsWhitelist);
          allowedProps.width = allowedProps?.width === '100%' ? '600px' : allowedProps?.width;
          return <amp-iframe {...allowedProps} sandbox="allow-scripts allow-same-origin" layout="responsive">{domToReact(children, optionsParse)}</amp-iframe>;
        }

        if (attribs
            && attribs.class === 'mc-featured-container card recommended-post'
            && attribs['data-sheets-userformat']) {
          const domain = post.link.replace(post.permalink, '');
          Sentry.withScope((scope) => {
            scope.setLevel(Sentry.Severity.Warning);
            Sentry.captureException(new Error(`Featured box isn't render on ${post.permalink} from site ${domain}`));
          });

          return <></>;
        }

        if (attribs && attribs['data-post']) {
          return <div id={attribs.id} className={attribs.class}>{domToReact(children, optionsParse)}</div>;
        }
      }
    };
    const checkIsUrl = (url) => /^(http|https):\/\/[^ "]+$/.test(url);
    // eslint-disable-next-line
    const checkContainsValidUrl = (url) => /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(url);
    const getValidUrl = (url) => url.replace(/"/g, '').split(' ').filter((u) => checkContainsValidUrl(u))[0];
    const checkInvalidHrefAmp = (url) => (checkIsUrl(url) || !isAmp ? url : getValidUrl(url));
    const setPropsValidValues = (props, ctx) => {
      if (props.href) {
        props.href = checkInvalidHrefAmp(props.href);
      }
      if (props.border) {
        props.border = 1;
      }
      if (ctx?.props?.style) {
        for (const [k, v] of Object.entries(ctx.props.style)) {
          if (v.includes('!important')) {
            ctx.props.style[k] = v.replace('!important', '').trim();
          }
        }
      }
    };
    const handleAmpErrors = (propsBlacklist, ctx) => {
      try {
        if (!isAmp || typeof (ctx) !== 'object') return;
        propsBlacklist.push('xmlLang');
        if (ctx.type === 'a' && ctx?.props?.href) {
          const propsWhitelist = [
            'href', 'referrerpolicy', 'rel', 'target'
          ];
          if (ctx.props.target !== '_blank') {
            propsBlacklist.push('target');
          }
          const deniedProps = omit(ctx.props, propsWhitelist);
          propsBlacklist = propsBlacklist.concat(Object.keys(deniedProps));
        }
        return propsBlacklist;
      } catch (error) {
        Sentry.captureException(error);
      }
    };
    // Parse HTML with options and return a object with all elements
    const htmlReactParsed = ParseImgs(parse(fixTextForParse(text), optionsParse));

    // Verify if we need to parser the HTML to insert ad on it.
    // For example, bibliography components don't have ads
    const htmlElementsParsed = (!preview && Object.keys(post).length)
      ? InsertAdUnit({ htmlInReact: htmlReactParsed, isPhone, width })
      : htmlReactParsed;

    const renderHtmlReact = (ctx) => {
      try {
        if (isAmp) {
          const tagsBlacklist = [
            'script', 'style'
          ];
          if (tagsBlacklist.includes(ctx?.type)) {
            return <></>;
          }
          if (ctx?.type === 'blockquote') {
            if (ctx.props.cite) {
              return (
                <amp-facebook
                  width="552"
                  height="310"
                  layout="responsive"
                  data-href={ctx.props.cite}
                >
                </amp-facebook>
              );
            }
            if (ctx?.props['data-instgrm-permalink']) {
              return (
                <amp-instagram
                  data-shortcode={ctx.props['data-instgrm-permalink'].split('/')[4]}
                  data-captioned
                  width="400"
                  height="400"
                  layout="responsive"
                >
                </amp-instagram>
              );
            }
          }
        }

        if (typeof (ctx) === 'object' && ctx?.type && !htmlTags.includes(ctx?.type)) {
          return map(Object.keys(ctx?.props), (child) => {
            if (child !== 'children') {
              return child.match(/^<[a-z]|[a-z]>$/gi) ? '' : renderHtmlReact(`${child} `);
            }
            return renderHtmlReact(ctx?.props?.children);
          });
        }

        if (typeof (ctx) === 'object' && ['a'].includes(ctx?.type) && (!ctx?.props?.id && ctx?.props?.name)) {
          const propsBlacklist = [
            'children', 'type'
          ];
          const allowedProps = omit(ctx?.props, propsBlacklist);
          return (
            <a key={uuid()} {...allowedProps} id={ctx?.props?.name}>
              { ctx?.props && ctx?.props?.children && renderHtmlReact(ctx?.props?.children) }
            </a>
          );
        }

        if (typeof (ctx) === 'object' && ['ul', 'ol'].includes(ctx?.type) && !ctx?.props?.children) {
          return null;
        }

        if (typeof (ctx) === 'object' && withoutElement.includes(ctx?.type) && ctx?.props?.children) {
          return renderHtmlReact(ctx?.props?.children);
        }

        if (typeof (ctx) === 'object' && ctx?.type === 'img') {
          return (
            <Image
              key={uuid()}
              className={get(ctx, 'props.className', '')}
              src={get(ctx, 'props.src', '/images/no-image_medium.png')}
              alt={get(ctx, 'props.alt', '')}
              width={+get(ctx, 'props.width', '')}
              height={+get(ctx, 'props.height', '')}
              srcSet={get(ctx, 'props.srcSet', '')}
              sizes={get(ctx, 'props.sizes', '')}
              lazy
            />
          );
        }
        // Replace ads element from htmlReactParsed elements after
        // process it using the InsertAdUnit, check more details on:
        // utils/RenderHtmlReact/InsertAdUnit
        if (typeof (ctx) === 'object' && ctx?.type === 'ads') {
          return (
            <AdManager
              id="article-content-ads"
              type="box"
              display={{
                desktop: !isPhone && post?.options?.ads === 'on',
                tablet: !isPhone && post?.options?.ads === 'on',
                mobile: isPhone && post?.options?.ads === 'on',
              }}
              // Define targets using post fields
              targets={{
                tags: post?.tags?.map((i) => i.name),
                postId: post.id,
                author: post?.author?.slug,
                authorId: post?.author?.id,
                section: 'single',
              }}
            />
          );
        }

        if (typeof (ctx) === 'object' && ctx?.type && !Array.isArray(ctx?.props?.children)) {
          const HtmlTag = `${ctx.type}`;
          let propsBlacklist = [
            'children', 'type'
          ];
          propsBlacklist = handleAmpErrors(propsBlacklist, ctx);
          const allowedProps = omit(ctx?.props, propsBlacklist);
          setPropsValidValues(allowedProps, ctx);

          return (
            <HtmlTag key={uuid()} {...allowedProps}>
              { ctx?.props && ctx?.props?.children && renderHtmlReact(ctx?.props?.children) }
            </HtmlTag>
          );
        }

        if (typeof (ctx) === 'object' && ctx?.type && Array.isArray(ctx?.props?.children)) {
          const HtmlTag = `${ctx.type}`;
          let propsBlacklist = [
            'children', 'type'
          ];
          propsBlacklist = handleAmpErrors(propsBlacklist, ctx);
          const allowedProps = omit(ctx?.props, propsBlacklist);
          setPropsValidValues(allowedProps, ctx);

          if (ctx?.props?.children?.length > 1) {
            return (
              <HtmlTag key={uuid()} {...allowedProps}>
                { ctx?.props && ctx?.props?.children && Array.isArray(ctx?.props?.children)
                  ? map(ctx?.props?.children, (el) => renderHtmlReact(el)) : ctx }
              </HtmlTag>
            );
          }
          return Array.isArray(ctx?.props?.children[0]) ? (
            <HtmlTag key={uuid()} {...allowedProps}>
              { ctx?.props && ctx?.props?.children[0] && Array.isArray(ctx?.props?.children[0])
                ? map(ctx?.props?.children[0], (el) => renderHtmlReact(el)) : ctx }
            </HtmlTag>
          ) : (
            <HtmlTag key={uuid()} {...allowedProps}>
              { ctx?.props && ctx?.props?.children && Array.isArray(ctx?.props?.children)
                ? renderHtmlReact(ctx?.props?.children[0]) : ctx }
            </HtmlTag>
          );
        }
      } catch (error) {
        Sentry.captureException(error);
      }
      return ctx;
    };

    return (
      <React.Fragment>
        { Array.isArray(htmlElementsParsed) && htmlElementsParsed.length // Verify if html parsed is a valid array and not empty
          ? htmlElementsParsed.map((content) => renderHtmlReact(content))
          : null }
      </React.Fragment>
    );
  } catch (error) {
    Sentry.captureException(error);
    return text;
  }
};

RenderHtmlReact.defaultProps = {
  withoutElement: [],
  preview: false,
  post: {}
};

RenderHtmlReact.propTypes = {
  withoutElement: PropTypes.array,
  preview: PropTypes.bool,
  post: PropTypes.object,
  text: PropTypes.string,

};

export default RenderHtmlReact;
